/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-05-23 15:04:38
 *
 *******************************************************/
// @flow
import { routes } from 'src/routes';
import {
  FilterMajor,
  ColorsMajor,
  CodeMajor,
  AddNoteMajor,
  ListMajor,
  MobileHorizontalDotsMajor,
  LockMajor
} from '@shopify/polaris-icons';

import FilterTree from 'src/assets/images/dashboard/onboarding/filter-tree.png';
import FilterStyle from 'src/assets/images/dashboard/onboarding/filter-style.png';
import EnableTheme from 'src/assets/images/dashboard/onboarding/enable-theme.png';
import SuggestionDictionary from 'src/assets/images/dashboard/onboarding/suggestion-dictionary.png';
import ProductRanking from 'src/assets/images/dashboard/onboarding/product-ranking.png';
import MergeValues from 'src/assets/images/dashboard/onboarding/merge-values.png';
import SwatchSettings from 'src/assets/images/dashboard/onboarding/swatch-settings.png';

export const CHECKLIST4 = [
  {
    title: 'AdminHTML.Checklist.Checklist4.checklist4_Step1_Title',
    description: 'AdminHTML.Checklist.Checklist4.checklist4_Step1_Description',
    button: 'AdminHTML.Checklist.Checklist4.checklist4_Step1_Button',
    actionLabel: 'Create now',
    action: routes.filterTree.list(),
    video: 'https://www.youtube.com/embed/i9PujfnkT88',
    thumbnail: FilterTree
  },
  {
    title: 'AdminHTML.Checklist.Checklist4.checklist4_Step2_Title',
    description: 'AdminHTML.Checklist.Checklist4.checklist4_Step2_Description',
    button: 'AdminHTML.Checklist.Checklist4.checklist4_Step2_Button',
    actionLabel: 'Edit filter style',
    action: routes.filterSettings.view(),
    video: 'https://www.youtube.com/embed/h4mYTEqJDsc',
    thumbnail: FilterStyle
  },
  {
    title: 'AdminHTML.Checklist.Checklist4.checklist4_Step3_Title',
    description: 'AdminHTML.Checklist.Checklist4.checklist4_Step3_Description',
    button: 'AdminHTML.Checklist.Checklist4.checklist4_Step3_Button',
    actionLabel: 'Set up theme',
    action: routes.themeSetup.view(),
    video: 'https://www.youtube.com/embed/BRbmvhUdnWk',
    thumbnail: EnableTheme
  }
];

export const ARTICLE3 = {
  checklistFilter: [
    {
      icon: ColorsMajor,
      title: 'AdminHTML.Dashboard.OnboardingArticles.checklistFilter1_Title',
      actionLabel: 'Display color swatches',
      url: 'OnboardingArticles_ColorSwatchDoc01'
    },
    {
      icon: CodeMajor,
      title: 'AdminHTML.Dashboard.OnboardingArticles.checklistFilter2_Title',
      actionLabel: 'Set up instant search',
      url: 'OnboardingArticles_InstantSearchDoc'
    },
    {
      icon: AddNoteMajor,
      title: 'AdminHTML.Dashboard.OnboardingArticles.checklistFilter3_Title',
      actionLabel: 'Add a search suggestion',
      url: 'OnboardingArticles_SuggestionDoc'
    }
  ],
  checklistSearch: [
    {
      icon: ListMajor,
      title: 'AdminHTML.Dashboard.OnboardingArticles.checklistSearch1_Title',
      actionLabel: 'Set up search fields',
      url: 'OnboardingArticles_SearchFieldDoc'
    },
    {
      icon: ColorsMajor,
      title: 'AdminHTML.Dashboard.OnboardingArticles.checklistSearch2_Title',
      actionLabel: 'Display color swatches',
      url: 'OnboardingArticles_ColorSwatchDoc02'
    },
    {
      icon: MobileHorizontalDotsMajor,
      title: 'AdminHTML.Dashboard.OnboardingArticles.checklistSearch3_Title',
      actionLabel: 'Create filter option or search by metafield ',
      url: 'OnboardingArticles_SearchByMetafieldDoc'
    }
  ],
  checklistPromotion: [
    {
      icon: LockMajor,
      title: 'AdminHTML.Dashboard.OnboardingArticles.checklistPromotion1_Title',
      actionLabel: 'Add a stop word',
      url: 'OnboardingArticles_StopWordDoc'
    },
    {
      icon: MobileHorizontalDotsMajor,
      title: 'AdminHTML.Dashboard.OnboardingArticles.checklistPromotion2_Title',
      actionLabel: 'Create filter option by metafield',
      url: 'OnboardingArticles_SearchByMetafieldDoc'
    },
    {
      icon: FilterMajor,
      title: 'AdminHTML.Dashboard.OnboardingArticles.checklistPromotion3_Title',
      actionLabel: 'Create a filter',
      url: 'OnboardingArticles_FilterDoc'
    }
  ]
};

export const ARTICLE4 = [
  {
    title: 'AdminHTML.Article.Article4.article4_Step1_Title',
    description: 'AdminHTML.Article.Article4.article4_Step1_Description',
    button: 'AdminHTML.Article.Article4.article4_Step1_Button',
    actionLabel: 'Add suggestions',
    action: routes.suggestionDictionary.view(),
    video: 'https://www.youtube.com/embed/VkacgfJBQOU',
    thumbnail: SuggestionDictionary
  },
  {
    title: 'AdminHTML.Article.Article4.article4_Step2_Title',
    description: 'AdminHTML.Article.Article4.article4_Step2_Description',
    button: 'AdminHTML.Article.Article4.article4_Step2_Button',
    actionLabel: 'Add your rules',
    action: routes.productRanking.view(),
    video: 'https://www.youtube.com/embed/QIsizV_zISU',
    thumbnail: ProductRanking
  },
  {
    title: 'AdminHTML.Article.Article4.article4_Step3_Title',
    description: 'AdminHTML.Article.Article4.article4_Step3_Description',
    button: 'AdminHTML.Article.Article4.article4_Step3_Button',
    actionLabel: 'Add your rules',
    action: routes.mergeValues.view(),
    video: 'https://www.youtube.com/embed/L0sPNEMcGCk',
    thumbnail: MergeValues
  },
  {
    title: 'AdminHTML.Article.Article4.article4_Step4_Title',
    description: 'AdminHTML.Article.Article4.article4_Step4_Description',
    button: 'AdminHTML.Article.Article4.article4_Step4_Button',
    actionLabel: 'Swatch settings',
    action: routes.swatchSettings.view(),
    video: 'https://www.youtube.com/embed/0CZf0OGA96w',
    thumbnail: SwatchSettings
  }
];
